import { useState } from "react";
import {
  Form,
  Container,
  Input,
  ContainerInput,
  ContainerTitulo,
  Label,
  Text,
  Button,
  Error,
  Message,
} from "../styles/contact";
import { Titulo } from "../styles/skills";
import validacion from "../helpers/validacionesForm";
import sendMail from "../helpers/sendMail";

const Contact = () => {
  const [input, setInput] = useState({
    nombre: "",
    email: "",
    subject: "",
    mensaje: "",
  });

  const [error, setError] = useState({ hayError: false });
  const [send, setSend] = useState({ isSend: "" });

  const handleChange = (e) => {
    setInput((input) => {
      return {
        ...input,
        [e.target.name]: e.target.value,
      };
    });
    setError(validacion(input));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (Object.keys(error).length) {
      setError((errors) => {
        return {
          ...errors,
          hayError: true,
        };
      });
    }
    setInput((input) => {
      return {
        ...input,
        nombre: "",
        email: "",
        subject: "",
        mensaje: "",
      };
    });
    const response = await sendMail(input);
    setSend((send) => {
      return {
        ...send,
        isSend: response.msg,
      };
    });
  };
  return (
    <Container>
      <ContainerTitulo>
        <Titulo>Contactame</Titulo>
      </ContainerTitulo>
      <ContainerInput>
        <Form>
          <Label>Nombre</Label>
          <Input
            type={"text"}
            name="nombre"
            value={input.nombre}
            onChange={(e) => handleChange(e)}
          ></Input>
          {error.hayError && <Error>{error.nombre}</Error>}
          <Label>Email</Label>
          <Input
            type={"email"}
            name="email"
            value={input.value}
            onChange={(e) => handleChange(e)}
          ></Input>
          {error.hayError && <Error>{error.email}</Error>}
          <Label>Subject</Label>
          <Input
            type={"text"}
            name="subject"
            value={input.subject}
            onChange={(e) => handleChange(e)}
          ></Input>
          {error.hayError && <Error>{error.subject}</Error>}
          <Label>Tu mensaje</Label>
          <Text
            rows={8}
            name="mensaje"
            value={input.mensaje}
            onChange={(e) => handleChange(e)}
          ></Text>
          {error.hayError && <Error>{error.mensaje}</Error>}
        </Form>
        <Button onClick={(e) => handleSubmit(e)}>Enviar</Button>
        {send.isSend && <Message>{send.isSend}</Message>}
      </ContainerInput>
    </Container>
  );
};

export default Contact;
